module.exports = __webpack_public_path__ + "img/sydz.20f81015.png";